import { Link } from "react-router-dom";
import VerdictBadge from "@/components/base/VerdictBadge";
import type { GossipItem } from "@/types";

export default function RelatedList({ items }: { items: GossipItem[] }) {
  if (items.length === 0) return null;

  return (
    <div className="border border-background-200 rounded-card bg-background-50 overflow-hidden">
      <div className="px-5 py-4 border-b border-background-200 bg-background-100">
        <h2 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-links-line text-primary-500"></i>
          相关鉴定
        </h2>
      </div>
      <ul className="divide-y divide-background-200">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={`/gossip/${item.id}`}
              className="block px-5 py-4 group hover:bg-background-100 transition-colors"
            >
              <div className="flex items-center gap-2 mb-2">
                <VerdictBadge verdict={item.verdict} size="sm" showIcon={false} />
                <span className="text-[11px] text-foreground-400">{item.category}</span>
              </div>
              <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                {item.title}
              </p>
              <p className="mt-2 font-mono-num text-[11px] text-foreground-400">
                可信度 {item.credibility} · {item.publishedAt}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}